import { createSlice } from "@reduxjs/toolkit";

import { GetProductReviews } from "../../reduxApi/website/ProductReview";

const ProductReviewSlice = createSlice({
  name: "CartCount",
  initialState: {
    status: "idle",
    Reviews: [],
    CartProducts: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetProductReviews.pending, (state) => {
        state.status = "pending";
      })
      .addCase(GetProductReviews.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.Reviews = action.payload.data;
        console.log("Reviews Response:", state.Reviews);
      });
  },
});

export default ProductReviewSlice.reducer;
